import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import { $feathers } from './storeLocal/feathers'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueKatex from 'vue-katex'
import VueInputAutowidth from 'vue-input-autowidth'
import VueFusionCharts from 'vue-fusioncharts'
import FusionCharts from 'fusioncharts'
import Column2D from 'fusioncharts/fusioncharts.charts'
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion'
require('vue2-animate/dist/vue2-animate.min.css')

Vue.use(VueCompositionApi)
Vue.use(VueYouTubeEmbed)
Vue.use(VueKatex)
Vue.use(VueInputAutowidth)
Vue.use(VueFusionCharts, FusionCharts, Column2D, FusionTheme)

Vue.config.productionTip = false

Vue.prototype.$feathers = $feathers
Vuex.Store.prototype.$feathers = $feathers

// Auth first before loading the app
$feathers.reAuthenticate()
  .catch((e) => {
    console.log(e)
  })
  .then(response => {
    if ('lastActivity' in window.localStorage && window.localStorage.lastActivity != null) {
      const lastActive = window.localStorage.lastActivity
      const now = new Date().getTime()
      // Get the difference in minutes
      const diff = (now - lastActive) / 60000
      if (diff > 15) {
        store.dispatch('logout')
        return $feathers.logout()
      }
    }
    if (typeof (response) !== 'undefined' && 'user' in response) {
      return $feathers.service('users').get(response.user._id)
    }
  })
  .then(user => {
    if (typeof (user) !== 'undefined') {
      $feathers.set('user', user)
      store.dispatch('login', user)
    }
  })
  // Render the app
  .then(() => {
    // eslint-disable-next-line no-new
    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  })
